import React, { Component } from "react";
import c from "classnames";
import Translator from "components/Translator";
import Carousel from "components/Carousel";
import styles from "./style.module.scss";

const offices = [
  // Milan
  {
    icon: {
      src: "milan.svg",
      alt: "igenius-milan"
    },
    location: "v1_people-title-7-milan",
    country: "v1_people-title-7-milan-location",
    description: "v1_people-title-7-milan-info"
  },
  // San Jose
  {
    icon: {
      src: "san-jose.svg",
      alt: "igenius-san-jose"
    },
    location: "v1_people-title-7-jose",
    country: "v1_people-title-7-jose-location",
    description: "v1_people-title-7-jose-info"
  },
  // Sierre
  {
    icon: {
      src: "sierre.svg",
      alt: "igenius-sierre"
    },
    location: "v1_people-title-7-sierre",
    country: "v1_people-title-7-sierre-location",
    description: "v1_people-title-7-sierre-info"
  },
  // London
  {
    icon: {
      src: "london.svg",
      alt: "igenius-london"
    },
    location: "v1_people-title-7-london",
    country: "v1_people-title-7-london-location",
    description: "v1_people-title-7-london-info"
  }
];

class Offices extends Component {
  render() {
    const officesBlocks = offices.map(office => (
      <Translator>
        {t => (
          <div
            className={c(
              styles.locationCard,
              "d-flex",
              "flex-column",
              "justify-content-center"
            )}
          >
            <div className="d-flex justify-content-between align-items-end">
              <span className="font-tt5">{t(office.location)}</span>
              <img
                className={styles.officesIcon}
                src={`/offices/${office.icon.src}`}
                alt={office.icon.alt}
              />
            </div>
            <div className={c("font-micro", "font-color-grey", styles.country)}>
              {t(office.country)}
            </div>
            <div className="font-mini-spacemono">{t(office.description)}</div>
          </div>
        )}
      </Translator>
    ));

    return (
      <div className={styles.Offices}>
        <div className={c("margin-bottom-48", styles.heading)}>
          <Translator>
            {t => <h2 className="font-tt3">{t("v1_people-title-7")}</h2>}
          </Translator>
        </div>
        <Carousel uniqueId="officesCarousel" slides={officesBlocks} />
      </div>
    );
  }
}

export default Offices;



// WEBPACK FOOTER //
// ./src/components/Offices/index.js